import MenuComponent from "../component/MenueComponent";
import { MyHeader } from "../header/MyHeader";
import { MyFooter } from "../landingpage/MyFooter";

export function Datenschutz() {

  return (
    <>

      {/*<MyHeader />*/}

      <div className="container">

        <div className="content row">

          <MenuComponent aktuelleseite="datenschutz" />

          <h2 style={{ textAlign: "center", width: "100%" }}>Datenschutz</h2>

          <h4 style={{ textAlign: "center", width: "100%" }}>volkslauf-neermoor.de</h4>

          <p>
            Wir möchten Sie über Art, Umfang und Zweck der von Ihnen erhobenen, genutzten und verarbeiteten personenbezogenen Daten
            informieren und über Ihre Rechte aufklären. Ihren Datenschutz nehmen wir sehr ernst. Ihre personenbezogenen Daten behandeln
            wir vertraulich und entsprechend der gesetzlichen Vorschriften. Wir behalten uns vor, diese Datenschutzinformation neuen
            Erfordernissen anzupassen. Für Ihren erneuten Besuch dieser Website gilt die eingestellte Fassung.
          </p>

          <p>
            Um die Sicherheit Ihrer personenbezogenen Daten bei der Übertragung mittels Kontaktformular zu schützen, erfolgt die Verbindung
            über HTTPS unter Nutzung eines SSL-Zertifikats. Beachten Sie dennoch bitte, dass die Datenübertragung im Internet grundsätzlich
            mit Sicherheitslücken bedacht sein kann. Ein vollständiger Schutz vor dem Zugriff durch Fremde ist nicht realisierbar.
          </p>

          <h3>Anfrage- und Vertragsdaten</h3>
          <p>
            Wir erheben und verarbeiten personenbezogene Daten, wenn diese zur Durchführung vertraglicher Maßnahmen benötigt werden.
          </p>

          <h3>Der Hoster dieser Domain verwendet WebAnalytics.</h3>

          <p>
            Die Daten werden entweder durch einen Pixel oder durch ein Logfile ermittelt. Zum Schutz von personenbezogenen Daten verwendet WebAnalytics keine Cookies.
          </p>

          <p />
          Es werden keine personenbezogenen Daten von Websitenbesuchern gespeichert, damit keine Rückschlüsse auf die einzelnen Besucher gezogen werden können. Es werden folgende Daten erhoben:

          Referrer (zuvor besuchte Webseite)
          Angeforderte Webseite oder Datei
          Browsertyp und Browserversion
          Verwendetes Betriebssystem
          Verwendeter Gerätetyp
          Uhrzeit des Zugriffs
          IP-Adresse in anonymisierter Form (wird nur zur Feststellung des Orts des Zugriffs verwendet)

          <p />

          In WebAnalytics werden Daten ausschließlich zur statistischen Auswertung und zur technischen Optimierung des Webangebots erhoben.

          <p />

          Es werden keine Daten an Dritte weitergegeben.

          <p />

          <h3>Dauer der Speicherung</h3>

          <h4>Daten für die Veranstaltungen</h4>

          Die Personenbezogenen und alle damit verbundenen Informationen werden nach 2 Jahren nach Beendigung der entsprechenden Veranstaltung gelöscht.

          <h4>Server-Log-Dateien</h4>
          <p />
          Die in den Logfiles erfassten IP-Adressen werden zur Sicherstellung des Betriebs bis zu 7 Tage gespeichert. Wo technisch möglich und sinnvoll wird die IP-Adresse nach 24 Stunden anonymisiert.
          <p /><p />

          <h4>Ihre Rechte</h4>
          <p />
          <h5>Auskunftsrecht</h5>

          Sie haben das Recht, jederzeit von uns unentgeltliche Auskunft über die zu ihrer Person gespeicherten personenbezogenen Daten und eine Kopie dieser Auskunft zu erhalten.
          <p />

          <h5>Berichtigungsrecht</h5>

          Sie haben das Recht, die unverzügliche Berichtigung Sie betreffender unrichtiger personenbezogener Daten zu verlangen. Ferner steht Ihnen das Recht zu, unter Berücksichtigung der Zwecke der Verarbeitung die Vervollständigung unvollständiger personenbezogener Daten — auch mittels einer ergänzenden Erklärung — zu verlangen.
          <p />
          <h5>Löschungsrecht</h5>

          Sie haben das Recht, die unverzügliche Löschung der sie betreffenden personenbezogenen Daten zu verlangen, sofern einer der folgenden Gründe zutrifft und soweit die Verarbeitung nicht erforderlich ist:

          <ul>
            <li>Die personenbezogenen Daten wurden für solche Zwecke erhoben oder auf sonstige Weise verarbeitet, für welche sie nicht mehr notwendig sind.</li>
            <li>Sie widerrufen ihre Einwilligung, auf die sich die Verarbeitung stützte, und es fehlt an einer anderweitigen Rechtsgrundlage für die Verarbeitung.</li>
            <li>Sie legen gemäß Art. 21 Abs. 1 DS-GVO Widerspruch gegen die Verarbeitung ein, und es liegen keine vorrangigen berechtigten Gründe für die Verarbeitung vor, oder Sie legen gemäß Art. 21 Abs. 2 DS-GVO Widerspruch gegen die Verarbeitung ein.</li>
            <li>Die personenbezogenen Daten wurden unrechtmäßig verarbeitet.</li>
            <li>Die Löschung der personenbezogenen Daten ist zur Erfüllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem wir unterliegen.</li>
            <li>Die personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gemäß Art. 8 Abs. 1 DS-GVO erhoben.</li>
          </ul>

          <p />
          <h5>Recht auf Einschränkung der Verarbeitung</h5>
          Sie haben das Recht die Einschränkung der Verarbeitung zu verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:

          <ul>
            <li>Die Richtigkeit der personenbezogenen Daten wird von Ihnen bestritten, und zwar für eine Dauer, die es uns ermöglicht, die Richtigkeit der personenbezogenen Daten zu überprüfen.</li>
            <li>Die Verarbeitung ist unrechtmäßig, Sie lehnen die Löschung der personenbezogenen Daten ab und verlangen stattdessen die Einschränkung der Nutzung der personenbezogenen Daten.</li>
            <li>Wir benötigen die personenbezogenen Daten für die Zwecke der Verarbeitung nicht länger, Sie benötigen sie jedoch zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.</li>
            <li>Sie haben Widerspruch gegen die Verarbeitung gem. Art. 21 Abs. 1 DS-GVO eingelegt und es steht noch nicht fest, ob unsere berechtigten Gründe gegenüber Ihren überwiegen.</li>
          </ul>
          <p />
          <h5>Widerspruchsrechte gegen die Verarbeitung</h5>

          Sie haben das Recht, jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten, die aufgrund von Art. 6 Abs. 1 Buchstaben e oder f DS-GVO erfolgt, Widerspruch einzulegen.
          Wir verarbeiten die personenbezogenen Daten im Falle des Widerspruchs nicht mehr, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die gegenüber Ihren Interessen, Rechten und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
          Sie haben das Recht, jederzeit Widerspruch gegen die Verarbeitung der personenbezogenen Daten zum Zwecke von Direktwerbung einzulegen.

          <p />
          <h5>Recht auf Datenübertragbarkeit</h5>
          Sie haben das Recht, die sie betreffenden personenbezogenen Daten, welche uns bereitgestellt wurden, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten. Sie haben außerdem das Recht, diese Daten einem anderen Verantwortlichen ohne Behinderung durch uns, zu übermitteln, sofern die Verarbeitung auf der Einwilligung gemäß Art. 6 Abs. 1 Buchstabe a DS-GVO oder Art. 9 Abs. 2 Buchstabe a DS-GVO oder auf einem Vertrag gemäß Art. 6 Abs. 1 Buchstabe b DS-GVO beruht und die Verarbeitung mithilfe automatisierter Verfahren erfolgt, sofern die Verarbeitung nicht für die Wahrnehmung einer Aufgabe erforderlich ist, die im öffentlichen Interesse liegt oder in Ausübung öffentlicher Gewalt erfolgt, welche dem Verantwortlichen übertragen wurde. Ferner haben Sie bei der Ausübung ihres Rechts auf Datenübertragbarkeit gemäß Art. 20 Abs. 1 DS-GVO das Recht, zu erwirken, dass die personenbezogenen Daten direkt von einem Verantwortlichen an einen anderen Verantwortlichen übermittelt werden, soweit dies technisch machbar ist und sofern hiervon nicht die Rechte und Freiheiten anderer Personen beeinträchtigt werden.

          <p />
          <h5>Recht auf Widerruf einer datenschutzrechtlichen Einwilligung</h5>
          Sie haben das Recht, die Einwilligung zur Verarbeitung personenbezogener Daten jederzeit zu widerrufen.

          <p />
          <h5>Beschwerderecht bei der Aufsichtsbehörde</h5>
          Sie haben das Recht sich jederzeit an eine Aufsichtsbehörde in dem Mitgliedstaat Ihres Aufenthaltsortes oder Arbeitsplatzes oder des mutmaßlichen Verstoßes zu wenden, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die EU-Datenschutzgrundverordnung verstößt.

        </div>
      </div>

      <MyFooter />
    </>
  );
}
